import { updateCollection } from '../api/collectionManager';
export const updateUserCollectionById = async (collectionId, items, headers, logger) => {
    const body = {
        removeItems: items,
    };
    return updateCollection(body, `collections/${collectionId}/items`, headers, logger);
};
